import React, { useEffect, useState } from 'react'
import { css } from '@emotion/core'
import { SocialLike } from '@fs/zion-icon'
import { IconButton } from '@fs/zion-ui'
import { useParams } from '@fs/zion-router'
import { useTranslation } from 'react-i18next'
import { useLikesDislikes } from '../hooks/likeDislikeHooks'

const likeRowStyle = css`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
`
const likeUnlikeIconStyle = css`
  margin-right: 8px;
  color: white !important;

  &:focus,
  &:hover {
    background: rgba(255, 255, 255, 0.25) !important;
  }
`
const likeStateReducer = (state, { type, payload }) => {
  switch (type) {
    case 'REQUEST_LIKES_DISLIKES':
      return { ...state, status: 'REQUEST_LIKES_DISLIKES' }
    case 'LIKES_DISLIKES_REQUESTED':
      return { ...state, status: 'LIKES_DISLIKES_REQUESTED' }
    case 'LIKES_DISLIKES_UPDATE_REQUESTED':
      return { ...state, status: 'LIKES_DISLIKES_UPDATE_REQUESTED', data: payload }
    case 'LIKES_DISLIKES_UPDATING':
      return { ...state, status: 'LIKES_DISLIKES_UPDATING' }
    default:
      return { ...state, status: 'REQUEST_LIKES_DISLIKES' }
  }
}

const getLikesDislikes = (ratings) => {
  const likes =
    ratings?.find((ratingGroup) => {
      return ratingGroup.rating === 1
    })?.guestCount ?? 0

  return { likes }
}

export default function LikeDislike({ contentId }) {
  const { t } = useTranslation()
  const { id } = useParams()

  const [likeState, likeStateDispatcher] = React.useReducer(likeStateReducer, {
    status: 'REQUEST_LIKES_DISLIKES',
    data: null,
  })

  const [updateLikeDislikesState, updateLikesDislikes] = useLikesDislikes()
  const [likes, setLikes] = useState()

  const like = () => {
    likeStateDispatcher({
      type: 'LIKES_DISLIKES_UPDATE_REQUESTED',
      payload: { cmsSessionId: contentId, method: 'PUT' },
    })
  }

  useEffect(() => {
    likeStateDispatcher({ type: 'REQUEST_LIKES_DISLIKES' })
  }, [id])

  useEffect(() => {
    if (likeState.status === 'LIKES_DISLIKES_UPDATE_REQUESTED') {
      updateLikesDislikes(likeState.data)
      likeStateDispatcher({ type: 'LIKES_DISLIKES_UPDATING' })
    }
  }, [likeState.data, likeState.status, updateLikesDislikes])

  useEffect(() => {
    if (likeState.status === 'REQUEST_LIKES_DISLIKES') {
      updateLikesDislikes({ cmsSessionId: contentId, method: 'GET' })
      likeStateDispatcher({ type: 'LIKES_DISLIKES_REQUESTED' })
    }
  }, [contentId, likeState.status, updateLikesDislikes])

  useEffect(() => {
    if (!updateLikeDislikesState.pending && updateLikeDislikesState.complete) {
      const likesDislikes = getLikesDislikes(updateLikeDislikesState?.response?.ratings)
      setLikes(likesDislikes.likes)
    }
  }, [updateLikeDislikesState.complete, updateLikeDislikesState.pending, updateLikeDislikesState.response])

  return (
    <div css={likeRowStyle}>
      <IconButton
        Icon={SocialLike}
        onClick={like}
        css={likeUnlikeIconStyle}
        aria-label={t('video.button-label.like', 'Like')}
      />
      <span style={{ marginRight: '20px' }}>{likes}</span>
    </div>
  )
}
